// Import will be used when implementing actions
// import { studentsApi } from '@/services/api'

// Initial state
const state = {
  students: [],
  loading: false,
  error: null
}

// Getters
const getters = {
  allStudents: state => state.students,
  isLoading: state => state.loading,
  error: state => state.error
}

// Mutations
const mutations = {
  SET_STUDENTS(state, students) {
    state.students = students
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

// Actions
const actions = {
  // Will be implemented as needed
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
} 